import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from 'components/atoms/custom-select';
import { createGetDepartmentWorkerOptions } from 'queries/departmentQueries';

function AssignExecutor(props) {
  const [name, setName] = useState('');
  const { t } = useTranslation();
  const { data, isLoading, error } = useQuery(
    createGetDepartmentWorkerOptions(
      {
        departmentId: props.departmentId,
        siteId: props.siteId,
      },
      {
        enabled: props.departmentId != null && props.siteId != null,
      }
    )
  );
  const options = data?.map(worker => {
    return {
      label: `${worker.FirstName} ${worker.LastName}`,
      value: worker.ID,
      Email: worker.Email,
    };
  });

  function handleChange(option) {
    setName(option);
    props.setActualEstimatedUserId(option.value);
    props.setActualEstimatedUserEmail(option.Email);
    props.setShowChangeExecutor(false);
  }
  return (
    <CustomSelect
      name={'executor'}
      id={'executor'}
      placeholder={t('Select Executor')}
      options={options?.length > 0 ? options : []}
      onChange={handleChange}
      value={name}
    />
  );
}

export default AssignExecutor;
